export default {
  radius: 3,
  margin: 8,
  padding: 16,
  maxWidth: 1100,
  containerPadding: 12
};